module.exports = __webpack_public_path__ + "img/notification-bell.d00db541.svg";